import Caterpie from './Caterpie';

export default Caterpie;



/** WEBPACK FOOTER **
 ** ./source/010-caterpie/index.js
 **/